import store from "store"

function getUserPaysource() {
  const authenticatedUser = store.getState().authentication.authenticatedUser
  return authenticatedUser?.user_paysources?.[0]
}

export default getUserPaysource
